export default __webpack_public_path__ + "static/media/clear_circle.e1759e95.svg";